import { render } from "./CustomerTypeManagement.vue?vue&type=template&id=7e0c4c0d"
import script from "./CustomerTypeManagement.vue?vue&type=script&lang=js"
export * from "./CustomerTypeManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__